/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react'
import { Input, Select, Form } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { SearchoptionsEnum, SearchSegmentsEnum } from '../../utils/Enums'
import { mdiMagnify, mdiMenuDown } from '@mdi/js'
import Icon from '@mdi/react'

const AdvancedSearchBar = (props) => {
	const { segment, tabStatus, collection, keyword, setKeyword, filterProperty, setFilterProperty } = props

	const [searchOptions, setSearchOptions] = useState([])

	useEffect(() => {
		const newSearchOptions =
			segment === 'BiltyOps' || segment === 'Trackers'
				? SearchSegmentsEnum[segment]?.filterProperties?.map((property) => ({
						key: property,
						value: SearchoptionsEnum[property]?.value,
				  }))
				: SearchSegmentsEnum[segment]?.filterProperties?.[tabStatus]?.map((property) => ({
						key: property,
						value: SearchoptionsEnum[property]?.value,
				  }))
		setSearchOptions(newSearchOptions)
		if (!newSearchOptions?.map((option) => option?.key)?.includes(filterProperty)) {
			setFilterProperty(newSearchOptions[0]?.key)
		}
	}, [segment, tabStatus, collection]) //eslint-disable-line

	const SearchBarAddOn = () => (
		<Select
			className=' bg-white pr-2 !text-secondary-400'
			suffixIcon={<Icon size={0.9} path={mdiMenuDown} />}
			defaultValue={searchOptions[0]?.key}
			onChange={(value) => setFilterProperty(value)}
			value={filterProperty}
		>
			{searchOptions?.map((option) => (
				<Select.Option key={option.key} value={option.key}>
					{option.value}
				</Select.Option>
			))}
		</Select>
	)

	return (
		<Input
			value={keyword}
			className={'h-[40px] pr-2 self-start !w-fit'}
			prefix={<SearchOutlined className='px-2' />}
			placeholder={props.placeholder}
			addonBefore={<SearchBarAddOn />}
			onChange={(event) => setKeyword(event.target.value)}
		/>
	)
}

export default AdvancedSearchBar
